var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiconPagination = function SvgMiconPagination(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M6 18H2v2h4zM30 18h-4v2h4zM24 22v6H8v-6H6v6a2.006 2.006 0 0 0 2 2h16a2.005 2.005 0 0 0 2-2v-6zM8 16V4h8v6a2.006 2.006 0 0 0 2 2h6v4h2v-6a.9.9 0 0 0-.3-.7l-7-7A.9.9 0 0 0 18 2H8a2.006 2.006 0 0 0-2 2v12zM18 4.4l5.6 5.6H18zM14 18h-4v2h4zM22 18h-4v2h4z"
  })));
};
export default SvgMiconPagination;